import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { agentsApi } from '../api/agentsApi';
import { agentsKeys } from '../queryKeys';

/**
 * Is an agent assigned to the current location?
 *
 * Assignment controls whether a location can start new work. Paused assignments still have task
 * history, so this value must not remove the Tasks route or its navigation link. Wait for success
 * before treating a location as unassigned.
 */
export function useAgentAssignment() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';

  const query = useQuery({
    queryKey: agentsKeys.assignment(locationId),
    queryFn: () => agentsApi.getAssignment(locationId),
    enabled: !!locationId,
    // Short enough that an agency hire shows here within one refocus/remount (RF S5).
    staleTime: 30_000,
  });

  return { ...query, isAssigned: query.data?.assigned === true, locationId };
}
